import { Component } from 'js-component-framework';

/**
 * Component for search page dropdowns functionality
 */
export default class SearchPageSubmitCheckboxes extends Component {
  /**
   * Start the component
   */
  constructor(config) {
    super(config);
    this.init();
  }

  init() {
    const {
      controller,
      form,
    } = this.children;

    if (! controller || ! form) {
      return;
    }

    controller.forEach((checkbox) => {
      checkbox.addEventListener('change', () => {
        form.submit();
      });
    });
  }
}
